import { useCallback, useEffect, useState } from "react";
import { TExternalProviderID } from "../models";
import { getExternalProviderIDs } from "../network";

export const useExternalProviderIDs = (
  verificationRequestId?: string,
): [
  TExternalProviderID[] | null,
  boolean,
  Error | null,
  (id?: string) => Promise<void>,
] => {
  const [result, setResult] = useState<TExternalProviderID[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const refresh = useCallback(
    async (id?: string): Promise<void> => {
      setIsLoading(true);
      setError(null);

      const requestId = id || verificationRequestId;

      if (!requestId) {
        setResult([]);
        setError(new Error("Verification request ID is not provided"));
        setIsLoading(false);
        return;
      }

      try {
        setResult(await getExternalProviderIDs(requestId));
      } catch (caught) {
        setResult([]);
        setError(
          caught instanceof Error ? caught : new Error("Unknown error"),
        );
      } finally {
        setIsLoading(false);
      }
    },
    [verificationRequestId],
  );

  useEffect(() => {
    if (verificationRequestId) {
      refresh();
    }
  }, [refresh, verificationRequestId]);

  return [result, isLoading, error, refresh];
};
